module.exports = __webpack_public_path__ + "static/media/book_250.a2040b15.jpg";